import { DOCUMENT, Inject, Injectable } from "@angular/core";

//https://juristr.com/blog/2019/08/dynamically-load-css-angular-cli/

@Injectable({
    providedIn: 'root'
})
export class CssLoader {

    constructor(@Inject(DOCUMENT) private document: Document) { }

    loadStyle(styleName: string) {
        const head = this.document.getElementsByTagName('head')[0];

        let themeLink = this.document.getElementById(
            'client-theme'
        ) as HTMLLinkElement;
        if (themeLink) {
            themeLink.href = styleName;
        } else {
            const style = this.document.createElement('link');
            style.id = 'client-theme';
            style.rel = 'stylesheet';
            style.type = "text/css";
            style.href = `${styleName}`;

            head.appendChild(style);
        }
    }

}